import { ResolveFn, Routes } from '@angular/router';
import { HomeComponent } from '@cashbox-app/pages/home/home.component';
import { InvoiceListComponent } from '@cashbox-app/pages/invoice-list/invoice-list.component';
import { MoneyReportComponent } from '@cashbox-app/pages/cash/money-report/money-report.component';
import { SettingsComponent } from '@cashbox-app/pages/settings/settings.component';
import { OrderViewComponent } from '@cashbox-app/pages/order-view/order-view.component';
import { OrderDeliveryComponent } from '@cashbox-app/pages/order-delivery/order-delivery.component';
import { OrderCashboxComponent } from '@cashbox-app/pages/order-cashbox/order-cashbox.component';
import { UserOrderComponent } from '@cashbox-app/pages/user-order/user-order.component';
import { FiscalizationComponent } from '@cashbox-app/pages/fiscalization/fiscalization.component';
import { inject } from '@angular/core';
import { HxOrderService, OrderResponse } from 'hx-services';
import { orderRoutes } from 'hx-order';

const orderResolveFn: ResolveFn<OrderResponse> = route => inject(HxOrderService)
  .getFullOrderById(Number(route.paramMap.get('id')));

export const ROUTES: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'sale'
      },
      {
        path: 'orders',
        children: orderRoutes,
      },
      {
        path: 'orders/:id',
        component: OrderViewComponent,
        pathMatch: 'full',
        resolve: {
          order: orderResolveFn,
        }
      },
      {
        path: 'delivery',
        component: OrderDeliveryComponent
      },
      {
        path: 'sale',
        component: OrderCashboxComponent
      },
      {
        path: 'invoices',
        component: InvoiceListComponent
      },
      {
        path: 'money-report',
        component: MoneyReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'money-report/full',
        component: UserOrderComponent,
        pathMatch: 'full'
      },
      {
        path: 'options',
        component: SettingsComponent,
      },
      {
        path: 'fiscalization',
        component: FiscalizationComponent,
      },
      {
        path: 'faq/list',
        loadComponent: () => import('hx-component').then(m => m.HxFaqListComponent)
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'sale'
  }
];
